
export default class WriterPaymentPolicy
{
    static seeOrderPayments(user)
    {
        return user.role_name === 'writer' || user.role_name === 'editor';
    }

    static managePayments(user)
    {
        return user.role_name === 'admin';
    }

}